export type WalletErrorType = 'BUYER_ACCOUNT_ERROR' | 'DEFAULT';
